import React from "react";
import { SectionTitle, BusinessList } from "components/items";
import makeTitle from "function/makeTitle.js";

import business_01 from "image/business-01.png";
import business_02 from "image/business-02.png";
import business_03 from "image/business-03.png";
import business_04 from "image/business-04.png";

const businessArr = [
	{
		id: "business-01",
		image: business_01,
		thumbnailText: ["OEM", "ODM"],
		title: "OEM・ODM",
		text: "동구밭 팩토리의 체계화된 품질관리와 다년 간의 연구개발로 만들어진 기술력으로 고객의 니즈에 맞는 상품을 생산합니다.",
	},
	{
		id: "business-02",
		image: business_02,
		thumbnailText: ["Hotel", "Amenity"],
		title: "호텔 어메니티",
		text: "지속가능성을 강조한 프리미엄 고체어메니티 상품을 제조 납품합니다.",
	},
	{
		id: "business-03",
		image: business_03,
		thumbnailText: ["Our Company", "Product"],
		title: "자사제품 제조판매",
		text: "동구밭의 가치를 담아 합리적이고, 기능성이 강조된 헤어/바디/페이스/베이비/리빙/D.I.Y 라인의 제품을 제조하여 자사 온라인몰에서 판매하고 있습니다.",
	},
	{
		id: "business-04",
		image: business_04,
		thumbnailText: ["Souvenir", "&", "Gift"],
		title: "기업행사/답례품",
		text: "기업의 행사 기념품, 명절 선물과 답례품으로 동구밭 제품을 납품하고 있습니다.",
	},
];

const sectionTitle = [
	{
		text: "BUSINESS",
		color: "default",
		break: false,
	},
	{
		text: "AREA",
		color: "main",
		break: true,
	},
];

const drawBusinessList = () => {
	return businessArr.map((el) => {
		return <BusinessList items={el} key={el.id} />;
	});
};

const BusinessArea = (props) => {
	return (
		<section className={`BusinessArea ${props.className}`}>
			<div className="con">
				<SectionTitle text={makeTitle(sectionTitle)} type="center" withText="false" />

				<div className="wrap-contents">
					<div className="wrap-businessList">{drawBusinessList()}</div>
				</div>
			</div>
		</section>
	);
};

export default BusinessArea;
